export default "__VITE_ASSET__baedf4f4__"